import { makeAutoObservable } from "mobx";
import { PROPOSAL_TYPE } from "../utils/constants";
import { ContentTemplateRequest } from "../requests/ContentTemplateRequest";

class ContentTemplateStore {
  items = [];

  //
  isLoadingForm = false;
  content = null;

  load = () => {
    this.items = Object.values(PROPOSAL_TYPE).map((item) => {
      return {
        key: item.key,
        label: item.label,
      };
    });
  };

  update = async (key, content) => {
    await ContentTemplateRequest.update(key, content);
  };

  getDetails = async (key) => {
    return new Promise((resolve, reject) => {
      ContentTemplateRequest.getDetails(key)
        .then((response) => {
          this.content = response.data.content;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  clear = () => {
    this.items = [];
    this.isLoadingForm = false;
  };
}

const contentTemplateStore = new ContentTemplateStore();
export default contentTemplateStore;
